import { makeStyles } from '@material-ui/core';

export const getProposalEditorSideBarSectionsListDraggableItemStyles =
  makeStyles(({ spacing }) => ({
    item: {
      padding: spacing(0.5, 0),
    },
  }));
